export default __webpack_public_path__ + "static/media/videos.c09d2f9f.svg";